import { ɵɵdefineInjectable, ɵsetClassMetadata, Injectable, ɵɵinject, Optional, ɵɵdefineComponent, ɵɵelementStart, ɵɵtext, ɵɵelementEnd, Component, ɵɵdefineNgModule, ɵɵdefineInjector, ɵɵsetNgModuleScope, NgModule, SkipSelf } from '@angular/core';
import { SHA256, AES, enc } from 'crypto-js';
import { __decorate, __param, __metadata } from 'tslib';

const SecureStorage = require('secure-web-storage');
const SECRET_KEY = '88D82318-510D-446A-826B-7B14F9AAC3C3';
class StorageService {
    constructor() {
        this.secureStorage = new SecureStorage(localStorage, {
            hash: function hash(key) {
                key = SHA256(key, SECRET_KEY);
                return key.toString();
            },
            encrypt: function encrypt(data) {
                data = AES.encrypt(data, SECRET_KEY);
                data = data.toString();
                return data;
            },
            decrypt: function decrypt(data) {
                data = AES.decrypt(data, SECRET_KEY);
                data = data.toString(enc.Utf8);
                return data;
            }
        });
    }
}
/** @nocollapse */ StorageService.ɵfac = function StorageService_Factory(t) { return new (t || StorageService)(); };
/** @nocollapse */ StorageService.ɵprov = ɵɵdefineInjectable({ token: StorageService, factory: StorageService.ɵfac, providedIn: 'root' });
/*@__PURE__*/ (function () { ɵsetClassMetadata(StorageService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return []; }, null); })();

class LocalStorageConfigConst {
}
LocalStorageConfigConst.activeEncrypt = false;

class LocalStorageConfig {
}

class LocalStorageConfigService {
    constructor(config) {
        this.kaadConfig = new LocalStorageConfig();
        if (config) {
            this.options = config;
        }
    }
    set options(opt) {
        this.kaadConfig.activeEncrypt = (opt && opt.activeEncrypt) ? opt.activeEncrypt : LocalStorageConfigConst.activeEncrypt;
    }
    getEncryptLocalStorage() {
        return this.kaadConfig.activeEncrypt;
    }
}
/** @nocollapse */ LocalStorageConfigService.ɵfac = function LocalStorageConfigService_Factory(t) { return new (t || LocalStorageConfigService)(ɵɵinject(LocalStorageConfig, 8)); };
/** @nocollapse */ LocalStorageConfigService.ɵprov = ɵɵdefineInjectable({ token: LocalStorageConfigService, factory: LocalStorageConfigService.ɵfac, providedIn: 'root' });
/*@__PURE__*/ (function () { ɵsetClassMetadata(LocalStorageConfigService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: LocalStorageConfig, decorators: [{
                type: Optional
            }] }]; }, null); })();

class LocalService {
    constructor(storageService, config) {
        this.storageService = storageService;
        this.config = config;
    }
    setJsonValue(key, value) {
        this.storageService.secureStorage.setItem(key, value);
    }
    getJsonValue(key) {
        return this.storageService.secureStorage.getItem(key);
    }
    removeJsonValue(key) {
        return this.storageService.secureStorage.removeItem(key);
    }
    clear() {
        if (this.config.getEncryptLocalStorage()) {
            this.storageService.secureStorage.clear();
        }
        else {
            localStorage.clear();
        }
    }
    setItem(key, value) {
        if (this.config.getEncryptLocalStorage()) {
            this.setJsonValue(key, value);
        }
        else {
            localStorage.setItem(key, value);
        }
    }
    getItem(key) {
        if (this.config.getEncryptLocalStorage()) {
            return this.getJsonValue(key);
        }
        else {
            return localStorage.getItem(key);
        }
    }
    removeItem(key) {
        if (this.config.getEncryptLocalStorage()) {
            this.removeJsonValue(key);
        }
        else {
            localStorage.removeItem(key);
        }
    }
}
/** @nocollapse */ LocalService.ɵfac = function LocalService_Factory(t) { return new (t || LocalService)(ɵɵinject(StorageService), ɵɵinject(LocalStorageConfigService)); };
/** @nocollapse */ LocalService.ɵprov = ɵɵdefineInjectable({ token: LocalService, factory: LocalService.ɵfac, providedIn: 'root' });
/*@__PURE__*/ (function () { ɵsetClassMetadata(LocalService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: StorageService }, { type: LocalStorageConfigService }]; }, null); })();

class LocalStorageComponent {
    constructor() { }
    ngOnInit() {
    }
}
/** @nocollapse */ LocalStorageComponent.ɵfac = function LocalStorageComponent_Factory(t) { return new (t || LocalStorageComponent)(); };
/** @nocollapse */ LocalStorageComponent.ɵcmp = ɵɵdefineComponent({ type: LocalStorageComponent, selectors: [["akeela-lib-localStorage"]], decls: 2, vars: 0, template: function LocalStorageComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵelementStart(0, "p");
        ɵɵtext(1, " local-storage works! ");
        ɵɵelementEnd();
    } }, encapsulation: 2 });
/*@__PURE__*/ (function () { ɵsetClassMetadata(LocalStorageComponent, [{
        type: Component,
        args: [{
                selector: 'akeela-lib-localStorage',
                template: `
    <p>
      local-storage works!
    </p>
  `,
                styles: []
            }]
    }], function () { return []; }, null); })();

class LocalStorageModule {
    constructor(parentModule) {
        if (parentModule) {
            throw new Error('SecurityModule is already loaded. Import it in the AppModule only');
        }
    }
    static config(config) {
        return {
            ngModule: LocalStorageModule,
            providers: [
                { provide: LocalStorageConfig, useValue: config }
            ]
        };
    }
}
/** @nocollapse */ LocalStorageModule.ɵmod = ɵɵdefineNgModule({ type: LocalStorageModule });
/** @nocollapse */ LocalStorageModule.ɵinj = ɵɵdefineInjector({ factory: function LocalStorageModule_Factory(t) { return new (t || LocalStorageModule)(ɵɵinject(LocalStorageModule, 12)); }, imports: [[]] });
__decorate([
    __param(0, Optional()),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [LocalStorageConfig]),
    __metadata("design:returntype", Object)
], LocalStorageModule, "config", null);
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵɵsetNgModuleScope(LocalStorageModule, { declarations: [LocalStorageComponent], exports: [LocalStorageComponent] }); })();
/*@__PURE__*/ (function () { ɵsetClassMetadata(LocalStorageModule, [{
        type: NgModule,
        args: [{
                imports: [],
                declarations: [LocalStorageComponent],
                exports: [LocalStorageComponent]
            }]
    }], function () { return [{ type: LocalStorageModule, decorators: [{
                type: Optional
            }, {
                type: SkipSelf
            }] }]; }, null); })();

/*
 * Public API Surface of local-storage
 */

/**
 * Generated bundle index. Do not edit.
 */

export { LocalService, LocalStorageComponent, LocalStorageModule };
//# sourceMappingURL=akeela-local-storage.js.map
